import FingerprintJS from '@fingerprintjs/fingerprintjs';

const fpPromise = FingerprintJS.load();

export const getFingerprint = () =>
  new Promise(resolve => {
    fpPromise.then((res) => {res.get().then((res) => {resolve(res.visitorId)})});
  });